import { render, staticRenderFns } from "./StudioIndex.vue?vue&type=template&id=fe5f56e2&scoped=true"
import script from "./StudioIndex.vue?vue&type=script&lang=js"
export * from "./StudioIndex.vue?vue&type=script&lang=js"
import style0 from "./StudioIndex.vue?vue&type=style&index=0&id=fe5f56e2&prod&lang=less&scoped=true"
import style1 from "./StudioIndex.vue?vue&type=style&index=1&id=fe5f56e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5f56e2",
  null
  
)

export default component.exports